import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Container,
  Alert,
  Table,
  Row,
  Col,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axios";
import "./myPage.css";

export default function MyPage() {
  const [formData, setFormData] = useState({
    memberType: "",
    userType: "",
    nameKor: "",
    nameEng: "",
    birthDate: "",
    email: "",
    organization: "",
    position: "",
    address: "",
    phone: "",
  });

  const [error, setError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [education, setEducation] = useState([
    { year: "", month: "", details: "" },
  ]);
  const [experience, setExperience] = useState([
    { year: "", month: "", details: "" },
  ]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axiosInstance.get("/api/user/detail");
        const userData = response.data.data;

        setFormData({
          userId: userData.userId,
          memberType: userData.memberType,
          userType: userData.userType,
          nameKor: userData.nameKor,
          nameEng: userData.nameEng,
          birthDate: userData.birthDate,
          email: userData.email,
          organization: userData.organization,
          position: userData.position,
          address: userData.address,
          phone: userData.phone,
        });

        // 학력 데이터가 없을 경우 빈 행 하나 추가
        setEducation(
          userData.educations?.length > 0
            ? userData.educations.map((edu) => ({
                year: edu.year,
                month: edu.month,
                details: edu.details,
              }))
            : [{ year: "", month: "", details: "" }]
        );

        // 경력 데이터가 없을 경우 빈 행 하나 추가
        setExperience(
          userData.experiences?.length > 0
            ? userData.experiences.map((exp) => ({
                year: exp.year,
                month: exp.month,
                details: exp.details,
              }))
            : [{ year: "", month: "", details: "" }]
        );
      } catch (err) {
        console.error("Failed to load user data:", err);
        setError("사용자 정보를 가져오는데 실패했습니다.");
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleAddRow = (type) => {
    if (type === "education") {
      setEducation([...education, { year: "", month: "", details: "" }]);
    } else if (type === "experience") {
      setExperience([...experience, { year: "", month: "", details: "" }]);
    }
  };

  const handleRemoveRow = (type, index) => {
    if (type === "education") {
      setEducation(education.filter((_, i) => i !== index));
    } else if (type === "experience") {
      setExperience(experience.filter((_, i) => i !== index));
    }
  };

  const handleInputChange = (type, index, field, value) => {
    const updater = type === "education" ? setEducation : setExperience;
    const data = type === "education" ? [...education] : [...experience];
    data[index][field] = value;
    updater(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestData = {
      ...formData,
      educations: education.map((edu) => ({
        year: edu.year || null,
        month: edu.month || null,
        details: edu.details || "",
      })),
      experiences: experience.map((exp) => ({
        year: exp.year || null,
        month: exp.month || null,
        details: exp.details || "",
      })),
    };

    try {
      setError("");
      setLoading(true);
      await axiosInstance.put(`/api/user/edit/${formData.userId}`, requestData);

      alert("회원 정보가 성공적으로 업데이트되었습니다.");
    } catch (err) {
      console.error("Failed to update user data:", err);
      setError("정보 업데이트 중 문제가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const getMemberTypeLabel = (memberType) => {
    switch (memberType) {
      case "REGULAR":
        return "정회원";
      case "ASSOCIATE":
        return "준회원";
      case "GROUP":
        return "단체회원";
      default:
        return "알 수 없음";
    }
  };

  return (
    <Container className="my-5">
      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Table bordered>
          <tbody>
            <tr>
              <td>회원구분</td>
              <td colSpan="3">{getMemberTypeLabel(formData.memberType)}</td>
            </tr>
            <tr>
              <td>성명</td>
              <td>
                <Form.Control
                  type="text"
                  name="nameKor"
                  value={formData.nameKor}
                  onChange={handleChange}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  name="nameEng"
                  value={formData.nameEng}
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <td>생년월일</td>
              <td colSpan="3">
                <Form.Control
                  type="date"
                  name="birthDate"
                  value={formData.birthDate}
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <td>E-mail</td>
              <td colSpan="3">{formData.email}</td>
            </tr>
            <tr>
              <td>소속기관</td>
              <td>
                <Form.Control
                  type="text"
                  name="organization"
                  value={formData.organization}
                  onChange={handleChange}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  name="position"
                  value={formData.position}
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <td>주소</td>
              <td colSpan="3">
                <Form.Control
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <td>전화</td>
              <td colSpan="3">
                <Form.Control
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </td>
            </tr>
          </tbody>
        </Table>

        {/* 학력사항 */}
        <h5>학력사항</h5>
        {education.map((edu, index) => (
          <Row key={index} className="align-items-center mb-3">
            <Col md={2} className="d-flex align-items-center">
              <Form.Control
                type="text"
                placeholder="YYYY"
                value={edu.year}
                maxLength="4"
                onChange={(e) =>
                  handleInputChange("education", index, "year", e.target.value)
                }
              />
              <span className="ms-2">년</span>
            </Col>
            <Col md={2} className="d-flex align-items-center">
              <Form.Control
                type="text"
                placeholder="MM"
                value={edu.month}
                maxLength="2"
                onChange={(e) =>
                  handleInputChange("education", index, "month", e.target.value)
                }
              />
              <span className="ms-2">월</span>
            </Col>
            <Col md={6}>
              <Form.Control
                type="text"
                placeholder="학력사항 입력"
                value={edu.details}
                onChange={(e) =>
                  handleInputChange(
                    "education",
                    index,
                    "details",
                    e.target.value
                  )
                }
              />
            </Col>
            <Col md={2} className="d-flex justify-content-end">
              {education.length > 1 && (
                <Button
                  variant="danger"
                  className="me-2"
                  onClick={() => handleRemoveRow("education", index)}
                >
                  삭제
                </Button>
              )}
              <Button
                variant="primary"
                onClick={() => handleAddRow("education")}
              >
                추가
              </Button>
            </Col>
          </Row>
        ))}

        {/* 경력사항 */}
        <h5>경력사항</h5>
        {experience.map((exp, index) => (
          <Row key={index} className="align-items-center mb-3">
            <Col md={2} className="d-flex align-items-center">
              <Form.Control
                type="text"
                placeholder="YYYY"
                value={exp.year}
                maxLength="4"
                onChange={(e) =>
                  handleInputChange("experience", index, "year", e.target.value)
                }
              />
              <span className="ms-2">년</span>
            </Col>
            <Col md={2} className="d-flex align-items-center">
              <Form.Control
                type="text"
                placeholder="MM"
                value={exp.month}
                maxLength="2"
                onChange={(e) =>
                  handleInputChange(
                    "experience",
                    index,
                    "month",
                    e.target.value
                  )
                }
              />
              <span className="ms-2">월</span>
            </Col>
            <Col md={6}>
              <Form.Control
                type="text"
                placeholder="경력사항 입력"
                value={exp.details}
                onChange={(e) =>
                  handleInputChange(
                    "experience",
                    index,
                    "details",
                    e.target.value
                  )
                }
              />
            </Col>
            <Col md={2} className="d-flex justify-content-end">
              {experience.length > 1 && (
                <Button
                  variant="danger"
                  className="me-2"
                  onClick={() => handleRemoveRow("experience", index)}
                >
                  삭제
                </Button>
              )}
              <Button
                variant="primary"
                onClick={() => handleAddRow("experience")}
              >
                추가
              </Button>
            </Col>
          </Row>
        ))}

        <div className="button-group mt-4 d-flex justify-content-center">
          <Button
            variant="primary"
            className="mx-2"
            onClick={() => navigate("/employment")}
          >
            재직증명서
          </Button>
          <Button
            type="submit"
            variant="primary"
            className="mx-2"
            disabled={loading}
          >
            {loading ? "저장 중..." : "저장"}
          </Button>
          <Button
            variant="success"
            className="mx-2"
            onClick={() => navigate("/approval-request")}
          >
            결재요청
          </Button>
          <Button
            variant="success"
            className="mx-2"
            onClick={() => navigate("/approval-request/list")}
          >
            결재목록
          </Button>
        </div>
      </Form>
    </Container>
  );
}
